export function loadRefundOrderList(range, keyword) {
  return {
    type: 'LOAD_REFUND_ORDER_LIST',
    range,
    keyword,
  };
}

export function loadRefundOrderListCompletion(range, keyword, data, error) {
  return {
    type: 'LOAD_REFUND_ORDER_LIST_COMPLETION',
    range,
    keyword,
    list: (data && data.listData) || [],
    error,
  };
}

export function loadRefund(recordId) {
  return {
    type: 'LOAD_REFUND',
    recordId,
  };
}

export function loadRefundCompletion(recordId, data, error) {
  return {
    type: 'LOAD_REFUND_COMPLETION',
    recordId,
    data,
    error,
  };
}

export function loadRefundRecordList(range, keyword) {
  return {
    type: 'LOAD_REFUND_RECORD_LIST',
    range,
    keyword,
  };
}

export function loadRefundRecordListCompletion(range, keyword, data, error) {
  return {
    type: 'LOAD_REFUND_RECORD_LIST_COMPLETION',
    range,
    keyword,
    list: (data && data.listData) || [],
    error,
  };
}

export function changeRefundExpressInfo(info) {
  return {
    type: 'CHANGE_REFUND_EXPRESS_INFO',
    info,
  };
}

export function createRefundExpress(recordId) {
  return {
    type: 'CREATE_REFUND_EXPRESS',
    recordId,
  };
}

export function createRefundExpressCompletion(recordId, error, data) {
  return {
    type: 'CREATE_REFUND_EXPRESS_COMPLETION',
    recordId,
    error,
    data,
  };
}

export function cancelApplyRefund(afterSaleId) {
  return {
    type: 'CANCEL_APPLY_REFUND',
    afterSaleId,
  };
}

export function cancelApplyRefundCompletion(afterSaleId, data, error) {
  return {
    type: 'CANCEL_APPLY_REFUND_COMPLETION',
    afterSaleId,
    data,
    error,
  };
}

export function createRefundRecord(orderSkuId) {
  return {
    type: 'CREATE_REFUND_RECORD',
    orderSkuId,
  };
}

export function createRefundRecordCompletion(orderSkuId, error, data) {
  return {
    type: 'CREATE_REFUND_RECORD_COMPLETION',
    orderSkuId,
    error,
    data,
  };
}

export function loadInfoForRefundRecordCreate(orderSkuId) {
  return {
    type: 'LOAD_INFO_FOR_REFUND_RECORD_CREATE',
    orderSkuId,
  };
}

export function loadInfoForRefundRecordCreateCompletion(
  orderSkuId,
  error,
  data
) {
  return {
    type: 'LOAD_INFO_FOR_REFUND_RECORD_CREATE_COMPLETION',
    orderSkuId,
    error,
    data,
  };
}

export function changeInputForRefundRecordCreate(input) {
  return {
    type: 'CHANGE_INPUT_FOR_REFUND_RECORD_CREATE',
    input,
  };
}

export function clearForRefundRecordCreate() {
  return {
    type: 'CLEAR_FOR_REFUND_RECORD_CREATE',
  };
}

export function clearForRefundExpressCreate() {
  return {
    type: 'CLEAR_FOR_REFUND_EXPRESS_CREATE',
  };
}

export function clearLoadOrderSkuList() {
  return {
    type: 'CLEAR_LOAD_ORDER_SKU_LIST',
  };
}

export function pickRefundAddress(address) {
  return {
    type: 'PICK_REFUND_ADDRESS',
    address,
  };
}

export function createRefundMoney(orderId) {
  return {
    type: 'CREATE_REFUND_MONEY',
    orderId,
  };
}

export function createRefundMoneyCompletion(orderId, error, data) {
  return {
    type: 'CREATE_REFUND_MONEY_COMPLETION',
    orderId,
    error,
    data,
  };
}

export function changeRefundMoneyCreateInfo(info) {
  return {
    type: 'CHANGE_REFUND_MONEY_CREATE_INFO',
    info,
  };
}

export function clearForRefundMoneyCreate() {
  return {
    type: 'CLEAR_FOR_REFUND_MONEY_CREATE',
  };
}

export function loadRefundMoney(orderId) {
  return {
    type: 'LOAD_REFUND_MONEY',
    orderId,
  };
}

export function loadRefundMoneyCompletion(orderId, error, data) {
  return {
    type: 'LOAD_REFUND_MONEY_COMPLETION',
    orderId,
    error,
    data,
  };
}
